import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { useTheme, Box } from "@mui/material";
import styles from "./datatable.module.css";
import { arSD } from "@mui/x-data-grid/locales";
const paginationModel = { page: 0, pageSize: 10 };

export default function DataTable(props) {
  const theme = useTheme();
  return (
    <Box
      className={styles.container}
      tabIndex={-1}
      aria-hidden="false"
      aria-modal="false"
      sx={{
        minHeight: "680px",
        display: "flex",
        flexDirection: "column",
      }}
      direction="rtl"
    >
      <DataGrid
        rows={props.data || []}
        getRowHeight={() => "auto"}
        columns={props.dataColumns}
        localeText={arSD.components.MuiDataGrid.defaultProps.localeText}
        initialState={{ pagination: { paginationModel } }}
        pageSizeOptions={[5, 10]}
        direction="rtl"
        loading={props.loading}
        slotProps={{
          loadingOverlay: {
            variant: "skeleton",
            noRowsVariant: "skeleton",
          },
        }}
        sx={{
          "& .MuiDataGrid-columnSeparator": {
            display: "none",
          },
          "& .MuiDataGrid-row": {
            minHeight: "60px !important", // Set minimum row height
          },
          "& .MuiDataGrid-cell": {
            color: theme.palette.text.primary,
            display: "flex",
            alignItems: "center", // Centers all cells vertically
          },
          backgroundColor: "white",
          border: 1,
          borderColor: theme.palette.neutral[300],
          borderRadius: "8px",
          width: "100%",
          height: "100%", // Set DataGrid height to fill the Box
          flexGrow: 1, // Allows DataGrid to expand within Box
        }}
      />
    </Box>
  );
}
